<nes-selectable-radio
  [checked]="isSelected"
  nes-id=""
  label=""
  filled="false"
  (nesOnClick)="selectProduct()"
>
  <div slot="header">
    <div class="nes-relative">
      <nes-heading tag="h3" size="2xl">{{
        "COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS." + product.identifier + ".TITLE"
          | translate
      }}</nes-heading>

      <div class="nes-absolute nes-right-0 nes-top-0">
        <ng-container
          *ngIf="
            product.identifier === ProductIdentifier.Traject &&
              !configuredProduct;
            else price
          "
        >
          <nes-text
            class="mb-2 nes-wrap"
            tag="span"
            weight="bold"
            [size]="{ xs: 'sm' }"
            color="text-heading"
          >
            {{
              "COMPOSE.PRODUCTS_OVERVIEW.PRICE_TRAJECT_DEPENDENT" | translate
            }}</nes-text
          >
        </ng-container>
        <ng-template #price>
          <nes-price
            [price]="
              configuredProduct
                ? configuredProduct.price / 100
                : product.price / 100
            "
            [stacked]="true"
            [trailingText]="
              '/' + ('FREQUENTION.MONTH_ABBREVIATION' | translate)
            "
            size="xl"
          >
          </nes-price>
        </ng-template>
      </div>
    </div>
    <div class="nes-text-default">
      <div
        *ngIf="
          product.identifier === 'BCB' || product.identifier === 'BCD';
          else trajectVrij
        "
      >
        {{ "COMPOSE.PRODUCTS_OVERVIEW.TRAVEL_ON_ACCOUNT" | translate }}
      </div>

      <ng-template class="nes-m-0" #trajectVrij>{{
        "COMPOSE.PRODUCTS_OVERVIEW.TRAVEL_UNLIMITED" | translate
      }}</ng-template>
    </div>
  </div>
  <div
    slot="content"
    *ngIf="
      'COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS.' +
        product.identifier +
        '.PROPS_IMPROVEMENT' | translate as properties
    "
  >
    <nes-text-list list-type="checked" size="base" color="text-body">
      <nes-text-list-item *ngFor="let prop of properties">{{
        prop
      }}</nes-text-list-item>
    </nes-text-list>

    <div *ngIf="configuredProduct?.route as route">
      <div
        class="route--container"
        [cypress]="'configured_product'"
        (click)="!routeLoading && chooseRoute.emit()"
      >
        <div class="route-column mt-1">
          <div *ngIf="route.from as from" class="route-row">
            <div class="route-dot"></div>
            <div class="route-line-down"></div>
            <div class="route-data">
              <strong>{{ from.naam }}</strong>
            </div>
          </div>
          <div *ngIf="route.to as to" class="route-row mt-1 mb-1">
            <div class="route-dot"></div>
            <div class="route-line-up"></div>
            <div class="route-data">
              <strong>{{ to.naam }}</strong>
            </div>
          </div>
        </div>
        <div
          *ngIf="routeLoading; else editIcon"
          class="basicLoader nes-self-center"
        ></div>
        <ng-template #editIcon>
          <div class="route-icon">
            <i class="icon edit--small"></i>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</nes-selectable-radio>

<div class="nes-flex nes-items-center">
  <nes-icon name="arrow-right" color="blue-500" class="nes-mr-2"></nes-icon>
  <nes-link
    href="#"
    (click)="emitReadMore(product)"
    [cypress]="'read_more'"
    [size]="'sm'"
  >
    {{ "COMPOSE.PRODUCTS_OVERVIEW.READ_MORE" | translate }}
    <span class="nes-font-bold">
      {{
        "COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS." + product.identifier + ".TITLE"
          | translate
      }}
    </span>
    {{ "COMPOSE.PRODUCTS_OVERVIEW.SUBSCRIPTION" | translate }}
  </nes-link>
</div>
